import * as React from "react";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { UpsellLayout } from "../../../../components/modules/Upsell/components/UpsellLayout.js";
import { UpsellCategory } from "../../../../layouts/modules/Upsell/layouts/UpsellCategory.js";
import { UpsellProducts } from "../../../../layouts/modules/Upsell/layouts/UpsellProducts.js";
/* empty css                                                   */
const productTypeSpecificMessageLabelMapping = {
  "contact-lenses": "cart.notification.upsell.contactLenses.message",
  "prescription-glasses": "cart.notification.upsell.prescriptionGlasses.message",
  "non-prescription-bundle": "cart.notification.upsell.nonRxBundle.message",
  frames: "cart.notification.upsell.frames.message",
  solutions: "cart.notification.upsell.solution.message",
  sunglasses: "cart.notification.upsell.sunglasses.message",
  "ready-readers": "cart.notification.upsell.readyReaders.message",
  accessories: "cart.notification.upsell.accessories.message"
};
const ProductTypeMessages = ({ lineItemTypes }) => {
  const { getLabel } = useIntl();
  const messages = lineItemTypes.map(
    (t) => getLabel(productTypeSpecificMessageLabelMapping[t], {
      hideLabelKey: true
    })
  ).filter(Boolean);
  if (messages.length <= 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, [...messages]);
};
const UpsellContainer = ({
  lineItems,
  products,
  recommendedCategoryKey
}) => {
  const { getLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      upsellCategoryHeading: getLabel("cart.notification.productAdded")
    }),
    [getLabel]
  );
  const lineItemTypes = [...new Set(lineItems.map((l) => l.productType))].filter(Boolean);
  if (recommendedCategoryKey) {
    return /* @__PURE__ */ React.createElement(UpsellLayout, { heading: labels.upsellCategoryHeading }, /* @__PURE__ */ React.createElement(ProductTypeMessages, { lineItemTypes }), /* @__PURE__ */ React.createElement(UpsellCategory, { recommendedCategoryKey }));
  }
  if (products) {
    return /* @__PURE__ */ React.createElement(UpsellLayout, { heading: labels.upsellCategoryHeading }, /* @__PURE__ */ React.createElement(ProductTypeMessages, { lineItemTypes }), /* @__PURE__ */ React.createElement(UpsellProducts, { products }));
  }
  return null;
};
export {
  UpsellContainer
};
//# sourceMappingURL=UpsellContainer.js.map
